// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_WIKI_REVIEWS_SEARCH = "Vyh\u013ead\u00e1vanie v Centre recenzi\u00ed";
